import { cn } from "@/lib/cn";

export function ChipGroup({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div>
      <p className="mb-3 text-[11px] font-bold uppercase tracking-wider text-muted">{label}</p>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onChange("")}
          className={cn("chip", !value ? "chip-active" : "chip-inactive")}
        >
          All
        </button>
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(value === opt ? "" : opt)}
            className={cn("chip", value === opt ? "chip-active" : "chip-inactive")}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}
